import { __decorate } from "tslib";
import { findIconDefinition, icon } from '@fortawesome/fontawesome-svg-core';
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationIconStyles as styles } from './icon.styles';
import { foundationIconTemplate as template } from './icon.template';
// explicitly declaring for extensibility
export const foundationIconShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
export const defaultIconConfig = {};
export var FaPrefixFromStyle;
(function (FaPrefixFromStyle) {
    FaPrefixFromStyle["solid"] = "fas";
    FaPrefixFromStyle["regular"] = "far";
    FaPrefixFromStyle["brand"] = "fab";
})(FaPrefixFromStyle || (FaPrefixFromStyle = {}));
/**
 * @tagname %%prefix%%-icon
 */
export class Icon extends FoundationElement {
    constructor() {
        super(...arguments);
        this.size = 'sm';
        this.variant = 'solid';
    }
    nameChanged(oldValue, newValue) {
        newValue ? this.loadIcon() : '';
    }
    sizeChanged(oldValue, newValue) {
        newValue ? this.loadIcon() : '';
    }
    variantChanged(oldValue, newValue) {
        newValue ? this.loadIcon() : '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.loadIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.iElement.replaceChildren();
    }
    loadIcon() {
        if (!this.iElement) {
            return;
        }
        const iconDefinition = findIconDefinition({
            prefix: FaPrefixFromStyle[this.variant],
            iconName: this.name,
        });
        const faIcon = icon(iconDefinition);
        if (faIcon && faIcon.node) {
            this.iElement.innerHTML = '';
            Array.from(faIcon.node).map((n) => this.iElement.appendChild(n));
        }
    }
}
__decorate([
    observable
], Icon.prototype, "iElement", void 0);
__decorate([
    attr
], Icon.prototype, "name", void 0);
__decorate([
    attr
], Icon.prototype, "size", void 0);
__decorate([
    attr
], Icon.prototype, "variant", void 0);
/**
 * The Foundation Icon
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-icon\>
 */
export const foundationIcon = Icon.compose(Object.assign({ baseName: 'icon', template,
    styles, shadowOptions: foundationIconShadowOptions }, defaultIconConfig));
